import React from 'react'
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import Modal from 'react-bootstrap/Modal';
import Loader from "../../shared/Loader/Loader";
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';

const PreviewFileModal = (props) => {

    const { modalActive, onClose, type, item, isLoading } = props

    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <Modal show={modalActive} onHide={() => onClose()} backdrop="static" keyboard={false} centered dialogClassName={`app-modal modal-md hk-login-v1 hk-modal-v1 ${['application/png', 'application/tiff','application/jpeg', 'application/jpg'].includes(type) ? 'ar_image_modal-new-changes' : ''} `}>
            <Modal.Body>
                <div className="download-header">
                    <div className='hide-me'></div>
                    {/* <button className="btn download-btn">
                 Download PDF
               </button> */}

                    <button className="btn-icon-transparent" onClick={() => onClose()}>
                        <i className="icon-x-cros fs-20 dark-clr"></i>
                    </button>
                </div>
                <div className="image-box">

                    {['application/png', 'application/tiff','application/jpeg', 'application/jpg'].includes(type)
                        ?
                        <div className="d-flex align-items-center justify-content-center">
                            <img src={item} alt='Image' className='mw-370px w-auto h-auto' />
                        </div>
                        :
                        type === 'application/txt'
                            ?
                            item
                            :
                            type === 'application/pdf'
                                ?
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                    <Viewer fileUrl={item}
                                        defaultScale={1}
                                        plugins={[defaultLayoutPluginInstance]} />
                                </Worker>
                                :
                                null}

                    {/* {!isNull(txtFile) ? txtFile : ''}
                    {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''} */}

                </div>
                {isLoading ? <Loader /> : null}

                {/* {pdfFile &&
                    <>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                            <Viewer fileUrl={pdfFile}
                                defaultScale={1}
                                plugins={[defaultLayoutPluginInstance]} />
                        </Worker>
                    </>
                } */}
            </Modal.Body>
            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end ar_footer'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => onClose()}>Cancel</button>
            </div>
        </Modal>
    )
}

export default PreviewFileModal
